(function () {
  const PAIR_MAP = {
    57266158272843: 57282956525899,
    57266031231307: 57282948858187,
  };

  let swapping = false;
  let cartCache = null;
  const _fetch = window.fetch.bind(window);

  _fetch('/cart.js').then(r => r.json()).then(cart => {
    cartCache = cart;
    attachSwapListeners();
  });

  function attachSwapListeners() {
    if (!cartCache?.items) return;
    cartCache.items.forEach((item, idx) => {
      const pairId = PAIR_MAP[item.variant_id];
      if (!pairId || item.quantity !== 1) return;
      const input = document.querySelector(`#CartDrawer .quantity__input[data-index="${idx + 1}"]`);
      if (!input) return;
      const btn = input.closest('.cart-item__quantity-wrapper')?.querySelector('button[name="plus"]');
      if (!btn || btn._ennui) return;
      btn._ennui = true;
      btn.addEventListener('click', function (e) {
        if (swapping) return;
        e.stopImmediatePropagation();
        e.preventDefault();
        doSwap(item, pairId);
      }, true);
    });
  }

  // Återanslut lyssnare när drawern öppnas
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    new MutationObserver(() => {
      if (!swapping) setTimeout(attachSwapListeners, 200);
    }).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  // Fånga tillägg från produktsidan
  window.fetch = async function (...args) {
    const result = await _fetch(...args);
    const url = (typeof args[0] === 'string' ? args[0] : args[0]?.url) || '';
    if (!swapping && /\/cart\/(add|change|update)/.test(url)) {
      try {
        result.clone().json().then(cart => { cartCache = cart; checkAndSwapWithData(cart); }).catch(checkAndSwap);
      } catch (e) { checkAndSwap(); }
    }
    return result;
  };

  function checkAndSwapWithData(cart) {
    if (swapping || !cart?.items) return;
    for (const item of cart.items) {
      const pairId = PAIR_MAP[item.variant_id];
      if (pairId && item.quantity >= 2) { doSwap(item, pairId); return; }
    }
  }

  async function checkAndSwap() {
    if (swapping) return;
    const cart = await _fetch('/cart.js').then(r => r.json());
    cartCache = cart;
    checkAndSwapWithData(cart);
  }

  async function doSwap(item, pairId) {
    swapping = true;
    const pairsToAdd = Math.floor(item.quantity / 2);
    const singlesLeft = item.quantity % 2;
    try {
      await _fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: singlesLeft }),
      });
      await _fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: pairId, quantity: pairsToAdd }),
      });
      cartCache = await _fetch('/cart.js').then(r => r.json());
      await refreshDrawer();
      attachSwapListeners();
    } finally {
      setTimeout(() => { swapping = false; }, 300);
    }
  }

  async function refreshDrawer() {
    const res = await _fetch('/?sections=cart-drawer');
    const data = await res.json();
    const html = data['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newInner = doc.querySelector('.drawer__inner');
    const cur = document.querySelector('#CartDrawer .drawer__inner');
    if (newInner && cur) cur.innerHTML = newInner.innerHTML;
    const newCount = doc.querySelector('.cart-count-bubble');
    const curCount = document.querySelector('.cart-count-bubble');
    if (newCount && curCount) curCount.innerHTML = newCount.innerHTML;
  }
})();